import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  variant?: 'default' | 'highlight' | 'glass';
  hoverEffect?: boolean;
}
export function Card({
  children,
  variant = 'default',
  hoverEffect = true,
  className = '',
  ...props
}: CardProps) {
  const baseStyles = 'rounded-3xl overflow-hidden relative';
  const variants = {
    default: 'bg-white border-2 border-candy-lavender shadow-xl shadow-candy-purple/5',
    highlight: 'bg-white border-4 border-candy-purple shadow-2xl shadow-candy-purple/20',
    glass: 'bg-white/70 backdrop-blur-lg border border-white/50 shadow-xl'
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} whileHover={hoverEffect ? {
    y: -8,
    rotate: 1
  } : {}} transition={{
    type: 'spring',
    stiffness: 300,
    damping: 20
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-192">
      {children}
    </motion.div>;
}